import React from 'react';
import Header from './Header';
import Footer from './Footer';
import LoadingIndicator from '../../components/LoadingIndicator';
import { useSession } from '../../context/SessionContext';
import '../../styles/Layout.css';

const Layout = ({ children }) => {
  const { isLoading } = useSession();

  return (
    <div className="layout-container">
      {/* Global loading indicator (shows while /Main/Main is in progress) */}
      <LoadingIndicator isLoading={isLoading} />
      <div className="container">
        <div className="row nopadding" style={{ paddingTop: '5px', paddingBottom: '5px' }}>
          <div className="col-lg-12 nopadding">
            <Header />
          </div>
        </div>

        <div className="row nopadding">
          <div className="col-lg-12">
            {/* Main content area */}
            {children}
          </div>
        </div>

        <div className="row">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Layout;